<template>
  <div class="serp__filter-dropdown-list--container q-container-fluid q-pb-2 q-d-flex"
       v-if="!noResultsState">
    <div class="serp__filter-dropdown-list q-justify-content-start q-d-flex q-flex-wrap q-col-12">
      <SortingButtonDropDown v-if="!noResultsState"/>
      <FilterDropdown v-for="filter in getFilters" :key="filter.field" :filter="filter"/>
      <ClearFiltersButton/>
    </div>
  </div>
</template>

<script setup lang="ts">
import FilterDropdown from "@/components/SerpPage/FiltersContainer/FiltersList/FilterDropdown.vue";
import ClearFiltersButton from "@/components/SerpPage/FiltersContainer/ClearFiltersButton/ClearFiltersButton.vue"
import SortingButtonDropDown from "@/components/SerpPage/ResultsContainer/ButtonsContainer/SortingButtonDropDown.vue"
import {storeToRefs} from "pinia";
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
const filtersStore = useFiltersStore();



const {getFilters} = storeToRefs(filtersStore)
const serpStore = useSerpResultsStore();
const {noResultsState} = storeToRefs(serpStore)


</script>

<style>
.serp__filter-dropdown-list >* {
  margin-right: 1rem;
  margin-top: 1rem;
}
</style>

